import {Component, OnInit, EventEmitter, inject} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {FieldConfig, ITrailingButtonEvent} from '../field.interface';
import {AppService} from '@app/app.service';
import {Moment} from 'moment';
import {MatDatepicker} from '@angular/material/datepicker';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {CUSTOM_YEAR_FORMATS, CustomDatePickerAdapter} from '@app/core/date-adapter';
import {getLanguage} from '@app/core/material.module';
import * as moment from 'moment';
import {takeUntil} from 'rxjs/operators';
import {TuiDestroyService} from '@taiga-ui/cdk';

@Component({
    selector: 'app-date-year',
    templateUrl: './date-year.component.html',
    styleUrls: ['../input/input.scss', '../date/date.component.scss', './date-year.component.css'],
    providers: [
        TuiDestroyService,
        {provide: MAT_DATE_FORMATS, useValue: CUSTOM_YEAR_FORMATS},
        {provide: MAT_DATE_LOCALE, deps: [AppService], useFactory: getLanguage},
        {provide: DateAdapter, useClass: CustomDatePickerAdapter, deps: [MAT_DATE_LOCALE]},
    ]
})
export class DateYearComponent implements OnInit {
    readonly #destroy$: TuiDestroyService = inject(TuiDestroyService);
    field: FieldConfig;
    group: FormGroup;
    data: any;
    max = null;
    min = null;

    /** Событие TrailingButton */
    outputEvent: EventEmitter<ITrailingButtonEvent> = null;

    dataFilter = (d: Date | Moment): boolean => {
        if (!this.max && !this.min) {
            return true;
        }
        if (!this.max && this.min) {
            return this.min <= d;
        }
        if (this.max && !this.min) {
            return this.max >= d;
        }
        if (this.max && this.min) {
            return this.max >= d >= this.min;
        }
    }

    constructor(public appService: AppService) {
    }

    ngOnInit() {
        this.getMax();
        this.getMin();

        if (this.data) {
            if (this.data.maxField && this.group.get(this.data.maxField)) {
                this.group.get(this.data.maxField)
                    .valueChanges
                    .pipe(takeUntil(this.#destroy$))
                    .subscribe(() => {
                        this.getMax();
                    });

                this.group.get(this.field.name)
                    .valueChanges
                    .pipe(takeUntil(this.#destroy$))
                    .subscribe(() => {
                        this.group.get(this.data.maxField).markAsTouched();
                        this.group.get(this.data.maxField).updateValueAndValidity({emitEvent: false});
                    });

            }
            if (this.data.minField && this.group.get(this.data.minField)) {
                this.group.get(this.data.minField)
                    .valueChanges
                    .pipe(takeUntil(this.#destroy$))
                    .subscribe(() => {
                        this.getMin();
                    });

                this.group.get(this.field.name).valueChanges
                    .pipe(takeUntil(this.#destroy$))
                    .subscribe(() => {
                        this.group.get(this.data.minField).markAsTouched();
                        this.group.get(this.data.minField).updateValueAndValidity({emitEvent: false});
                    });
            }
        }
        if (this.field.disabled) {
            setTimeout(() => {
                this.group.get(this.field.name).disable({onlySelf: true, emitEvent: false});
            });
        }
    }

    /**
     * Изменение года
     * @param normalizedYear выбранный год
     * @param datepicker поле
     */
    chosenYearHandler(normalizedYear: Moment, datepicker: MatDatepicker<any>) {
        let ctrlValue = this.group.get(this.field.name).value
            ? this.group.get(this.field.name).value
            : moment().month(0).date(1).hour(0).minute(0).second(0)
                .add(moment().utcOffset(), 'm').utc(false);
        if (typeof ctrlValue == 'string') {
            ctrlValue = moment(ctrlValue, 'YYYY').month(0).date(1).hour(0).minute(0).second(0)
                .add(moment().utcOffset(), 'm').utc(false);
        }
        ctrlValue.year(normalizedYear.year());
        this.group.get(this.field.name).setValue(ctrlValue);
        datepicker.close();
    }

    /**
     * Получение максимального ограничения
     */
    getMax() {
        if (this.data && this.data.maxDate) {
            this.max = this.data.maxDate;
        } else if (this.data && this.data.maxField) {
            if (typeof this.group.get(this.data.maxField).value == 'string') {
                this.max = moment(this.group.get(this.data.maxField).value, 'YYYY').month(0).date(1).hour(0).minute(0).second(0)
                    .add(moment().utcOffset(), 'm').utc(false);
            } else {
                this.max = this.group.get(this.data.maxField).value;
            }
        } else {
            this.max = null;
        }
    }

    /**
     * Получение минимального ограничения
     */
    getMin() {
        if (this.data && this.data.minDate) {
            this.min = this.data.minDate;
        } else if (this.data && this.data.minField) {
            if (typeof this.group.get(this.data.minField).value == 'string') {
                this.min = moment(this.group.get(this.data.minField).value, 'YYYY').month(0).date(1).hour(0).minute(0).second(0)
                    .add(moment().utcOffset(), 'm').utc(false);
            } else {
                this.min = this.group.get(this.data.minField).value;
            }
        } else {
            this.min = null;
        }
    }

    /**
     * Установка запрета изменения поля
     * @param disabled значение флага
     */
    setDisabled(disabled) {
        this.field.disabled = disabled;
        if (this.field.disabled) {
            this.group.get(this.field.name).disable({onlySelf: true, emitEvent: false});
        } else {
            this.group.get(this.field.name).enable({onlySelf: true, emitEvent: false});
        }
    }
}
